<script>
    export default {
        name: 'NormalCommentArea',
        props: {
            siteName: {
                required: true,
                type: String
            }
        },
        data () {
            return {
                dataList: []
            };
        },
        methods: {
            fetchCommentList () {
                this.$api(this.$util.url('api', 'comments'), {
                    questionnaire_id: window._CONFIG.question_data.id,
                    per_page: 500,
                    page: 1
                }, {
                    method: 'GET'
                }).then(v => {
                    console.log(v);
                    this.dataList = v.pagination.data || [];
                }).catch(error => {
                    this.$modal.alert({
                        text: '获取评论列表失败：' + error.errmessage
                    });
                }).finally(() => this.$util.setIframeHeight());
            }
        },
        mounted () {
            this.fetchCommentList();
        }
    };
</script>
<template>
    <div v-if="dataList.length">
        <div class="commentarea__title">
            选登评论
        </div>
        <template v-for="item in dataList">
            <div class="comment" :key="item.id">
                <div class="comment__client">
                    <span class="comment__client-avatar">&#xe715;</span>
                    <span class="comment__client-nickname">{{item.name}}</span>
                </div>
                <div class="comment__content" v-html="item.content"></div>
                <div class="comment__reply" v-if="item.reply">
                    <div class="comment__reply-deptname">{{siteName}}：</div>
                    <div class="comment__reply-content" v-html="item.reply.content"></div>
                </div>
            </div>
        </template>
    </div>
</template>
<style scoped lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .commentarea__title {
        color: @otherBigTitleClr;
        .px2rem(font-size, 28);
        font-weight: bold;
        .px2rem(margin-top, 90);
        .px2rem(padding-bottom, 34);
        border-bottom: 1px solid @otherGreyBgClr;
    }

    .comment {
        width: 100%;
        font-family: 'cmsicon';
        border-bottom: 1px solid @otherGreyBgClr;
        .px2rem(margin-top, 30);
        .px2rem(padding-bottom, 30);

        &__client {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .px2rem(height, 50);
            .px2rem(margin-bottom, 20);

            &-avatar {
                color: @otherTextClr;
                .px2rem(font-size, 50);
                .px2rem(margin-right, 17)
            }

            &-nickname {
                color: @otherTextClr;
                .px2rem(font-size, 28);
            }
        }

        &__content {
            .px2rem(font-size, 28);
            color: @otherNormalTitleClr;
            font-weight: 400;
            line-height: 1.5;
        }

        &__reply {
            width: 100%;
            background-color: @otherBtnHoverClr;
            .px2rem(margin-top, 20);
            .px2rem(padding, 20);
            position: relative;

            &:after {
                content: '\e6a1';
                font-family: cmsicon;
                position: absolute;
                color: #f0f2f4;
                .px2rem(top, -30);
                .px2rem(left, 30);
                .px2rem(font-size, 40);
            }

            &-deptname {
                .px2rem(font-size, 28);
                .px2rem(margin-bottom, 8);
                color: @otherNormalTitleClr;
                font-weight: bold;
            }

            &-content {
                .px2rem(font-size, 28);
                color: @otherNormalTitleClr;
                font-weight: 400;
                line-height: 1.5;
            }
        }
    }
</style>
